export class ApAlert {
    id: string;
    htmlBaseId: string;
    type: ApAlertType;
    message: string;
    autoClose = false;
    autoCloseTimeout = 5000;
    fade: boolean;

  constructor(init?: Partial<ApAlert>) {
        Object.assign(this, init);
    }
}

export enum ApAlertType {
    Success,
    Error,
    Warning,
    Info,
}
